import { render, staticRenderFns } from "./QuoteDistributionRouter.vue?vue&type=template&id=14372679&"
import script from "./QuoteDistributionRouter.vue?vue&type=script&lang=js&"
export * from "./QuoteDistributionRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports